<portal-sub-nav [force]="force" route="enterprise-call-center">
  <portal-menu-context [heading]="'menu.callCenter' | portalTranslate"></portal-menu-context>

  <!-- Groups -->
  <portal-sub-nav-item route="enterprise-call-center-queues">
    <span *portalTransclude>{{ 'menu.callCenter.queues' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Agents -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_CALLCENTER_AGENTS],
    }"
    route="enterprise-call-center-agents"
  >
    <span *portalTransclude>{{ 'menu.callCenter.agentsSupervisors' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Settings -->
  <portal-sub-nav-item route="enterprise-call-center-settings">
    <span *portalTransclude>{{ 'menu.settings' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Phone Book -->
  <portal-sub-nav-item route="enterprise-call-center-phone-book">
    <span *portalTransclude>{{ 'acd.cc.tab.phonebook' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Announcements -->
  <portal-sub-nav-item route="enterprise-call-center-announcements">
    <span *portalTransclude>{{ 'menu.callCenter.announcements' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Skills/Status -->
  <portal-sub-nav-item route="enterprise-call-center-skills-states">
    <span *portalTransclude>{{ 'menu.callCenter.skillsAndStates' | portalTranslate }}</span>
  </portal-sub-nav-item>

  <!-- Reports -->
  <portal-sub-nav-item route="enterprise-call-center-reports">
    <span *portalTransclude>{{ 'menu.callCenter.reporting' | portalTranslate }}</span>
  </portal-sub-nav-item>
</portal-sub-nav>
